export default __webpack_public_path__ + "static/media/joystickActive.3834ea5f.svg";